/** 種類: 新着 */
export const HOTLINE_PRO_MYPAGE_LIST_ITEM_TYPE_NEW = 'new';
/** 種類: 今後の相談予定 */
export const HOTLINE_PRO_MYPAGE_LIST_ITEM_TYPE_SCHEDULED = 'scheduled';
